import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      backgroundColor: "white",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "16px",
    },
    title: {
      fontSize: "24px",
      color: "#101828",
      fontWeight: 700,
      marginBottom: "16px",
    },
    innerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    miniTitle: {
      color: "black",
      fontSize: "20px",
      fontWeight: 700,
    },
    cardsContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      marginTop: "16px",
      marginBottom: "16px",
    },
    chartsContainer: {
      marginTop: "16px",
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      flexWrap: "wrap",
      position: "relative",
      maxHeight: "550px", // Limit height to enable scrolling
      overflowY: "auto",
    },
  })();
};
